import CircleOcticon from '@github-ui/circle-octicon'
import {AlertFillIcon, AlertIcon, CheckCircleIcon, CircleSlashIcon, SkipIcon, XCircleIcon} from '@primer/octicons-react'

export type MiniStatusIconProps = {
  type: 'success' | 'warning' | 'failure' | 'neutral' | 'empty' | 'error'
}

const configByType = {
  success: {className: 'fgColor-success bgColor-success-muted', Icon: CheckCircleIcon},
  warning: {className: 'fgColor-attention bgColor-attention-muted', Icon: AlertIcon},
  failure: {className: 'fgColor-danger bgColor-danger-muted', Icon: XCircleIcon},
  neutral: {className: 'fgColor-muted bgColor-neutral-muted', Icon: CircleSlashIcon},
  empty: {className: 'fgColor-muted bgColor-neutral-muted', Icon: SkipIcon},
  error: {className: 'fgColor-danger bgColor-danger-muted', Icon: AlertFillIcon},
}

export function MiniStatusIcon({type}: MiniStatusIconProps) {
  const {className, Icon} = configByType[type]

  return (
    <CircleOcticon
      className={className}
      data-testid={`mini-status-icon-${type}`}
      icon={() => <Icon size={16} />}
      size={20}
    />
  )
}
